import { cn } from '@/lib/utils';
import Image, { type ImageProps } from 'next/image';
import Link from 'next/link';

type CoverImageProps = {
  title: string;
  src: string;
  slug?: string;
  className?: string;
  priority?: boolean;
  loading?: ImageProps['loading'];
};

export default function CoverImage({
  title,
  src,
  slug,
  className,
  priority = true,
  loading,
}: CoverImageProps) {
  const image = (
    <Image
      width={2000}
      height={500}
      alt={`Cover Image for ${title}`}
      src={src}
      className={cn(
        'shadow-small rounded-xl h-50dvh object-cover',
        {
          'hover:shadow-medium transition-shadow duration-200': slug,
        },
        className,
      )}
      priority={priority}
      loading={loading}
    />
  );
  return (
    <div className="sm:mx-0">
      {slug ? (
        <Link href={`/posts/${slug}`} aria-label={title}>
          {image}
        </Link>
      ) : (
        image
      )}
    </div>
  );
}
